import React from "react";
import "css/components/loading-ellipsis.css";

const LoadingEllipsis=()=>{
    return <div className="loading-ellipsis"></div>;
};


export default LoadingEllipsis;